<template>
  <view>
    <view class="b-flex b-flex-warp a-w-100%">
      <view
        class="commoly-item a-h-102 a-bg-#F7F8FA a-br-6 a-mb-10 a-f a-ai-c b-flex-bettwen a-p-20"
        v-for="(item, index) in commolyUseds"
        :key="index"
        :class="[{ ' a-mr-10': index % 2 == 0 }]"
      >
        <view class="a-w-190">
          <view class="a-f a-ai-c">
            <text
              class="a-fs-24 a-lh-24 tripwise_fill"
              :class="[
                { 'icon-home_fill a-c-#FA8C16': item.productCode == 1 },
                { 'icon-company_fill a-c-#057BFF': item.productCode == 2 },
                { 'icon-train_fill a-c-#45B8A9': item.productCode == 3 },
                { 'icon-airport_fill a-c-#057BFF': item.productCode == 4 },
                { 'icon-district_fill a-c-#057BFF': item.productCode == 99 || !item.productCode },
              ]"
            ></text>
            <view class="a-ml-10 a-fs-28 a-lh-28 a-c-#14 a-w-156 over-ellipsis">{{
              item.remark || item.productName
            }}</view>
          </view>
          <view class="a-mt-10 a-fs-24 a-lh-24 a-c-#8c over-ellipsis">
            {{ item.remark ? item.productName || '暂未设置' : item.id ? item.arrivalInfo : '暂未设置' }}
          </view>
        </view>
        <view
          @click="handle(item)"
          class="a-w-80 a-h-48 a-bg-#F85A5B a-br-6 a-fs-20 a-lh-20 a-fw-500 a-c-#fff a-flex a-ai-c a-jc-c"
        >
          {{ item.id ? '打车' : '设置' }}
        </view>
      </view>
    </view>
  </view>
</template>

<script>
export default {
  props: {
    commolyUseds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    handle(item) {
      if (item && item.id) {
        this.$emit('toUseCar', item);
      } else {
        this.$emit('toSetCarPlace', item);
      }
    },
  },
};
</script>
<style scoped lang="less" scoped>
.commoly-item {
  width: calc(50% - 6rpx);
}
</style>
